export const notNeedAuthorization=[
    '/market/ig/account/getByUserId',
    '/market/ig/account/getDetailList',
    '/market/recommend/page',
    '/market/recommendGoods/page',
    '/market/igruledescription/getInfo'
]